import styled from 'styled-components';

export default styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background: white;
  opacity: 0.7;
  cursor: wait;
  width: 100%;
  height: 100%;
  z-index: 3;
  border-radius: 4px;
  text-align: center;

  .ant-modal-footer {
    border: 0;
  }
`;

export const Container = styled.div`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`;

export const Title = styled.h1`
  margin-top: 2px;
`;

export const Subtitle = styled.h2`
  margin-top: 80px;
  font-weight: normal;
  font-size: 17px;
`;
